// trasowanie.ts — przekład ścieżek źródeł na JEDNO wejście Control Center.
//
// ┌─ DLACZEGO PRZEKŁAD, A NIE PRZEPISANIE STU WYWOŁAŃ ──────────────────────────────────────────┐
// │ Ekrany wołają dziś adresy źródeł wprost: `client.get('crm', '/api/crm/analytics/school-sales')`.│
// │ Te ścieżki są dobrą dokumentacją — czytając wywołanie, wiadomo, skąd biorą się liczby.       │
// │                                                                                              │
// │ Zmiana dotyczy nie tego, CZEGO ekran chce, tylko KOGO o to pyta. Przeglądarka przestaje      │
// │ chodzić do CRM i do Drive; chodzi wyłącznie do Control Center, a Control Center sięga do     │
// │ źródeł własną tożsamością serwisową. Przekład ścieżki jest więc jedyną rzeczą, która musi    │
// │ się zmienić — i siedzi w jednym pliku, nie w stu komponentach.                               │
// └──────────────────────────────────────────────────────────────────────────────────────────────┘

/** Wejście backendu Control Center. Jedno pochodzenie, jedna sesja, jedno ciasteczko. */
export const PREFIKS_CC = '/api/cc';

/**
 * Reguły przekładu. Kolejność ma znaczenie: pierwsza pasująca wygrywa, więc reguły szczegółowe
 * stoją przed ogólnymi.
 *
 * `/api/admin/analytics` → `/api/cc/drive/analytics`, bo w Control Center system nazywa się
 * „drive", a nie „admin". Nazwa `admin` w Drive opisuje ROLĘ wołającego, nie dziedzinę danych,
 * i przeniesienie jej tutaj myliłoby dwie różne rzeczy.
 */
const REGULY: ReadonlyArray<readonly [RegExp, string]> = [
  [/^\/api\/crm\/analytics(?=\/|$)/, `${PREFIKS_CC}/crm/analytics`],
  [/^\/api\/crm\/dictionary(?=\/|$)/, `${PREFIKS_CC}/crm/dictionary`],
  [/^\/api\/crm\/transactions(?=\/|$)/, `${PREFIKS_CC}/crm/transactions`],
  [/^\/api\/admin\/analytics(?=\/|$)/, `${PREFIKS_CC}/drive/analytics`],
];

/**
 * Przekłada ścieżkę źródła na ścieżkę Control Center.
 *
 * Ścieżka już wskazująca Control Center przechodzi bez zmian — inaczej podwójny przekład
 * dokleiłby prefiks drugi raz. Ścieżka NIEZNANA przechodzi bez zmian CELOWO: cichy przekład
 * czegoś, czego backend nie montuje, dałby 404 pod adresem, którego nikt nie napisał, a wtedy
 * szuka się błędu w backendzie zamiast w tej tabeli.
 */
export function naControlCenter(sciezka: string): string {
  if (sciezka.startsWith(PREFIKS_CC)) return sciezka;
  for (const [wzor, cel] of REGULY) {
    if (wzor.test(sciezka)) return sciezka.replace(wzor, cel);
  }
  return sciezka;
}

/** Czy ta ścieżka ma w ogóle swój odpowiednik po stronie Control Center. */
export function czyPrzekladalna(sciezka: string): boolean {
  return sciezka.startsWith(PREFIKS_CC) || REGULY.some(([wzor]) => wzor.test(sciezka));
}
